import React, { useState } from 'react';
import { isMobile } from '@/biz/tool';
import BottomDrawer from '@/components/web/components/BottomDrawer';
import WebModal from '@/components/web/components/Modal';
import VerificationContent from './verificationContent';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { useLocation } from 'react-router-dom';

// 邮箱验证弹窗
const ModalEmailVerification: React.FC = () => {
  const router = useLocation();
  const isClerkPage = router.pathname.startsWith('/clerk');
  const {
    showModalEmailVerification,
    setShowModalEmailVerification,
    setCloseModalEmailVerification
  } = useWebModalStore();

  // 加载跳转页不显示改弹窗
  if (isClerkPage) {
    return null;
  }

  return (
    <>
      {isMobile() ? (
        <BottomDrawer
          visible={showModalEmailVerification}
          isShowFooter={false}
          width={isMobile() ? 402 : 624}
          handleClose={() => {
            setShowModalEmailVerification(false);
            setCloseModalEmailVerification(true);
          }}
          // 页面级别 最上层
          rootClassName="!z-[9999]"
          keepMounted={true}
        >
          <div className="-mt-[16px]">
            <VerificationContent sendEmail={showModalEmailVerification} />
          </div>
        </BottomDrawer>
      ) : (
        <WebModal
          modalStyle={{ zIndex: 1400 }}
          visible={showModalEmailVerification}
          isShowFooter={false}
          width={isMobile() ? 402 : 660}
          handleClose={() => {
            setShowModalEmailVerification(false);
            setCloseModalEmailVerification(true);
          }}
          keepMounted={true}
        >
          <div className="-mt-[45px]">
            <VerificationContent sendEmail={showModalEmailVerification} />
          </div>
        </WebModal>
      )}
    </>
  );
};

export default ModalEmailVerification;
